export interface AssessmentVerifyTranslations {
  title: string;
  desc: string;
  dobLabel: string;
  continueButton: string;
  errors: {
    enterDob: string;
    unexpectedError: string;
    incorrectDob: string;
  }
}

export const assessmentVerifyTranslationKeys: AssessmentVerifyTranslations = {
  title: 'title',
  desc: 'desc',
  dobLabel: 'dobLabel',
  continueButton: 'continueButton',
  errors: {
    enterDob: 'errors.enterDob',
    unexpectedError: 'errors.unexpectedError',
    incorrectDob: 'errors.incorrectDob',
  },
};

export const assessmentVerifyTranslationsEN: AssessmentVerifyTranslations = {
  title: 'Assessment',
  desc: 'Please enter your date of birth',
  dobLabel: 'Date of Birth (mm/dd/yyyy)',
  continueButton: 'Continue',
  errors: {
    enterDob: 'Please enter your date of birth',
    unexpectedError: 'An unexpected error occurred',
    incorrectDob: 'Incorrect date of birth',
  },
};

export const assessmentVerifyTranslationsES: AssessmentVerifyTranslations = {
  title: 'Evaluación',
  desc: 'Por favor, ingrese su fecha de nacimiento',
  dobLabel: 'Fecha de nacimiento (mm/dd/aaaa)',
  continueButton: 'Continuar',
  errors: {
    enterDob: 'Por favor, ingrese su fecha de nacimiento',
    unexpectedError: 'Ocurrió un error inesperado',
    incorrectDob: 'Fecha de nacimiento incorrecta',
  },
};
